import { type ReactNode } from 'react';

import { Tabs, TabsList, TabsTrigger } from '@apps/web/components/ui/tabs';

export type PrimaryTabDefinition = {
    readonly label: string;
    readonly value: string;
};

export function PrimaryTabs(props: {
    readonly tabs: ReadonlyArray<PrimaryTabDefinition>;
    readonly defaultValue?: string;
    readonly children: ReactNode;
}): ReactNode {
    const { tabs, defaultValue, children } = props;
    return (
        <Tabs
            defaultValue={defaultValue ?? tabs[0]?.value}
            className="flex min-w-0 flex-1 flex-col gap-2 lg:min-h-[48rem] lg:overflow-hidden"
        >
            <TabsList className="shrink-0">
                {tabs.map((tab) => (
                    <TabsTrigger key={tab.value} value={tab.value}>
                        {tab.label}
                    </TabsTrigger>
                ))}
            </TabsList>
            <div
                className="min-w-0 flex-1 lg:min-h-0 lg:overflow-hidden"
                data-testid="admin-trace-main-tab-panel"
            >
                <div className="flex h-full min-w-0 flex-col lg:min-h-0 lg:overflow-hidden">
                    {children}
                </div>
            </div>
        </Tabs>
    );
}
